import { defineComponent, h } from 'vue';
import { QAvatar } from 'quasar';
import utils from '../../../Shared/utils.jsx';
import methods from '../../../Shared/methods.js';
import DesignerRegistryMixin from './DesignerRegistryMixin.jsx';

function resolveFontSize(size) {
    if (!size)
        return '';

    let sz = 1;
    switch (size) {
        case 'xx-smaller': sz = 0.72; break;
        case 'x-smaller': sz = 0.8; break;
        case 'smaller': sz = 0.9; break;
        case 'normal': sz = 1; break;
        case 'larger': sz = 1.2; break;
        case 'x-larger': sz = 1.6; break;
        case 'xx-larger': sz = 2.4; break;
        case 'humongous': sz = 4; break;
        case 'colossal': sz = 6; break;
        case 'x-colossal': sz = 8; break;
        case 'xx-colossal': sz = 10; break;
    }
    // Adding 0.3 - Quasar vs. Vuetify is different, things appear smaller in Quasar
    return `${sz / 2.5}em`;
}

export default defineComponent({
    name: 'basic-avatar-dsgn',
    mixins: [DesignerRegistryMixin],
    components: { QAvatar },
    data: function () {
        return {
        }
    },
    created() {
    },
    computed: {
        Root: function () {
            return this.root;
        },
        textStyles: function () {
            const styles = {};

            //if (this.controlData.FontSize)
            //    styles['font-size'] = utils.resolveFontSize(this.controlData.FontSize);

            if (this.controlData.Color)
                styles.color = this.controlData.Color;
            else
                styles.color = '#444';

            return styles;
        },
        fontSize() {
            return resolveFontSize(this.controlData.FontSize);
        },
        selected$: function () {
            return this.Root.SelectedNode && this.Root.SelectedModel == this.designmodel;
        },
    },
    methods: {
        ...methods,
        handleClick(e) {
            this.Root.SelectNode(this);
            e.cancelBubble = true;
            e.stopPropagation();
        },
    },
    props: {
        name: '',
        root: null,
        designmodel: null,
        parentType: '',
        controlData: {}
    },
    render() {
        const style = {
            ...utils.getSize(this.controlData.SizeOptions, this.parentType, this.$parent),
            ...this.textStyles,
        };

        return (
            <QAvatar
                color={this.controlData.Color || 'blue-4'}
                size={this.controlData.BackgroundSize + 'px'}
                fontSize={this.fontSize}
                class={{ 'c-Avatar': true, 'designer-container': true, selected: this.selected$ }}
                onClick={(e) => this.handleClick(e)}
            >
                <div class={{ "designer-container-hovering": true, 'designer-container-selected': this.selected$ }} style="border-radius: 20px;"></div>
                <span
                    title={this.controlData.Tooltip}>
                    {this.controlData.Text || 'Empty'}
                </span>
            </QAvatar>
        );
    }
});